import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cb9f5c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal_census" }
const _hoisted_2 = { class: "avatar" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "mod_pagin"
}

import { computed, ref, reactive, watch } from 'vue';
import { Table, Pagination } from 'ant-design-vue';
import { CensusForm } from '../type';
import http from '@/api';
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'CensusModal',
  emits: ['click:disabled'],
  setup(__props, { emit }) {

const aTable = Table;
const aPagination = Pagination;
const columns = computed(() => {
  return [
    {
      title: '序号',
      dataIndex: 'index',
      key: 'index',
      width: 70,
    },
    {
      title: '用户头像',
      dataIndex: 'avatar_url',
      key: 'avatar_url',
      slots: { customRender: 'image' },
    },
    {
      title: '用户昵称',
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
    },
    {
      title: '用户ID',
      dataIndex: 'uid',
      key: 'uid',
    },
    {
      title: '地理位置',
      dataIndex: 'addr',
      key: 'addr',
    },
    {
      title: '答题时长',
      dataIndex: 'time',
      key: 'time',
    },
    {
      title: '答题时间',
      dataIndex: 'start_at',
      key: 'start_at',
      ellipsis: true,
    },
    {
      title: '答题状态',
      dataIndex: 'pass',
      key: 'pass',
      slots: { customRender: 'status' },
    },
    {
      title: '来源访问',
      dataIndex: 'referrer',
      key: 'referrer',
      ellipsis: true,
    },
    {
      title: '设备访问',
      dataIndex: 'device',
      key: 'device',
    },
  ];
});

const route = useRoute();
const studioId = computed(() => route.params.studioId);

const list = ref<CensusForm[]>([]);

const pageConfig = reactive({
  current: 1, // 当前页
  pageSize: 10, // 每页条数
  totalSize: 0, // 总页数
  options: ['10', '24', '36', '48', '60'], // 选项
  size: 'small', // 尺寸
  showJumper: false, // 是否显示跳页
  showSize: false, // 是否显示条数切换
});



const getAnswerRecord = () => {
  const data = { studio_id: studioId.value, page: pageConfig.current, page_num: pageConfig.pageSize };
  http.liveAnswer
    .getAnswerRecord({ params: data })
    .then((res) => {
      if (res.data.data.data && res.data.data.data.length > 0) {
        list.value = res.data.data.data;
        pageConfig.totalSize = res.data.data.total;
      }
    })
    .catch((err) => console.error(err.data.error));
};
getAnswerRecord();

const getExport = computed(() => {
  if (list.value.length === 0) {
    return true;
  } else {
    return false;
  }
});
watch(
  () => getExport.value,
  () => {
    emit('click:disabled', getExport.value);
  }
);
emit('click:disabled', getExport.value);

const formatColor = (keyword: number) => {
  if (keyword) {
    return '#00ccb0';
  } else {
    return '#ff6363';
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(aTable), {
      class: "",
      columns: _unref(columns),
      "data-source": list.value,
      pagination: false,
      rowKey: "index",
      size: "small",
      scroll: { y: 340 }
    }, {
      image: _withCtx(({ record }) => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: record.avatar_url
          }, null, 8, _hoisted_3)
        ])
      ]),
      status: _withCtx(({ record }) => [
        _createElementVNode("span", {
          style: _normalizeStyle({ color: formatColor(record.pass) })
        }, _toDisplayString(record.pass ? '通过' : '未通过'), 5)
      ]),
      _: 1
    }, 8, ["columns", "data-source"]),
    (list.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_unref(aPagination), {
            "show-quick-jumper": "",
            total: pageConfig.totalSize,
            current: pageConfig.current,
            "onUpdate:current": _cache[0] || (_cache[0] = ($event: any) => ((pageConfig.current) = $event)),
            "page-size": pageConfig.pageSize,
            "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((pageConfig.pageSize) = $event)),
            pageSizeOptions: pageConfig.options,
            "show-less-items": "",
            "show-size-changer": "",
            onChange: getAnswerRecord,
            onShowSizeChange: getAnswerRecord
          }, null, 8, ["total", "current", "page-size", "pageSizeOptions"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})